<template>
  <div class="header-box" ref="header">
    <div class="fr" @click="isShow = !isShow">
      <div class="nickname cursor">
        {{ INFO.name }}
      </div>
			<div
				v-if="isShow"
			 class="user-box">
				<!-- <router-link :to="{name:'userInfo'}">我的信息</router-link> -->
				<div class="cursor" @click="logout">退出</div>
			</div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "topHeader",
  data() {
    return {
			isShow:false,
			cIndex:-1,
		};
  },
	methods:{
		...mapMutations('user',[
			'CLEAR_USER_INFO'
		]),
		logout(){
			localStorage.removeItem('token');
			localStorage.removeItem('refresh_token');
			localStorage.removeItem('access_token');
			this.CLEAR_USER_INFO();
			this.$router.replace({
				name:'login'
			})
		}
	},
  mounted() {
		document.addEventListener('click', (e)=> {
			if(this.$refs.header && !!this.$refs.header.contains(e.target)) return false;
			this.isShow = false;
		})
  },
  computed: {
    ...mapGetters("user", ["INFO"]),
  },
};
</script>
<style scoped>
.header-box {
  line-height: 60px;
	position: relative;
}
.user-box{
	line-height: 40px;
	padding: 0 10px;
	background: #fff;
	border-radius: 3px;
	border: 1px solid #ccc;
	position: absolute;
	z-index: 10;
	min-width: 80px;
	right: 0;
	top: 60px;
}
.user-box::before{
	content: '';
	width: 7px;
	height: 7px;
	border-left: 1px solid #ccc;
	border-top: 1px solid #ccc;
	background: #fff;
	transform: rotate(45deg);
	position: absolute;
	right: 15px;
	top: -5px;
}
</style>


// WEBPACK FOOTER //
// src/components/topHeader.vue